import { DateInput } from './DateInput';
import { NumberInput } from './NumberInput';
import { ParsedNumberInput } from './ParsedNumberInput';
import { TextInput } from './TextInput';
import { YearInput } from './YearInput';
export * from './enums';
export var Input = {
  Text: TextInput,
  Number: NumberInput,
  Date: DateInput,
  Year: YearInput,
  ParsedNumber: ParsedNumberInput
};